import * as yup from 'yup';

export const getRegisterSignUpStepForm = yup.object().shape({
  email: yup.string().email('Adresse email est invalide').required('Une adresse email est requise'),
  password: yup
    .string()
    .min(6, 'Votre mot de passe doit contenir au moins 6 caractères')
    .required('Un mot de passe est requis'),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'Les mots de passe ne correspondent pas')
    .required('La confirmation de votre mot de passe est requise'),
});
